<template>
 <b-navbar class="fondo">
        <template #brand>
            <b-navbar-item>
                <button class="mobile-menu-btn" type="button" @click="toggleSidebarMobile" aria-label="Abrir menu">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ path: '/' }">
                <span class="brand-mini">Grupos <strong>LLDM</strong></span>
            </b-navbar-item>
        </template>
        <!-- items moved to sidebar -->

        <template #end>
            <b-navbar-item v-if="esSuperNav" tag="router-link" :to="{ path: '/configurar' }">
                <b-icon
                    icon="cogs"
                    size="is-medium">
                </b-icon>
                <span></span>
                Configurar
            </b-navbar-item>

            <b-navbar-item  tag="router-link" :to="{ path: '/perfil' }">
                <b-icon
                    icon="account"
                    size="is-medium">
                </b-icon>
                <span> </span>
                {{ usuario }}
            </b-navbar-item>
            <b-navbar-item v-if="actuando">
                <div class="acting-as-label">Actuando como: <strong>{{ grupoNombre }}</strong></div>
                <div class="buttons">
                    <a class="button is-danger is-light" @click="salirModoGrupo">Salir de grupo</a>
                </div>
            </b-navbar-item>
            <b-navbar-item >
                <div class="buttons">
                    <a class="button is-light" @click="salir">
                        Salir
                    </a>
                </div>
            </b-navbar-item>
        </template>
    </b-navbar>
</template>
<script>
    import AyudanteSesion from '../Servicios/AyudanteSesion'

    export default {
        name: "EncabezadoComponent",

        data:()=>({
                usuario: "",
                actuando: false,
                grupoNombre: ''
        }),

        computed: {
                esSuperNav(){ return AyudanteSesion.esSuper() && !this.actuando }
        },

        mounted(){
            const datos = AyudanteSesion.obtenerDatosSesion()
            this.usuario = datos.usuario
            this.actuando = AyudanteSesion.actuandoComoGrupo()
            this.grupoNombre = localStorage.getItem('grupoSeleccionadoNombre') || ''
            // actualizar cuando se cambie el grupo o se salga
            window.addEventListener('grupoSeleccionadoChanged', ()=>{
                const d = AyudanteSesion.obtenerDatosSesion()
                this.usuario = d.usuario
                this.actuando = AyudanteSesion.actuandoComoGrupo()
                this.grupoNombre = localStorage.getItem('grupoSeleccionadoNombre') || ''
            })
        },

        methods: {
                toggleSidebarMobile(){
                    try{ window.dispatchEvent(new CustomEvent('toggleSidebarMobile')) }catch(e){ void e }
                },
                salir(){
                    AyudanteSesion.cerrarSesion()
                },
                salirModoGrupo(){
                    AyudanteSesion.salirActuando()
                    // actualizar UI
                    const d = AyudanteSesion.obtenerDatosSesion()
                    this.usuario = d.usuario
                    this.actuando = false
                    this.grupoNombre = ''
                }
        }
    }
</script>
<style scoped>
.mobile-menu-btn{
    border: 1px solid #e9ecf5;
    background: #f8f9fd;
    width: 40px;
    height: 36px;
    border-radius: 10px;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    cursor: pointer;
}
.mobile-menu-btn:hover{ background: #efecff; border-color: #ddd6fe; }
.mobile-menu-btn span{
    display:block;
    width: 18px;
    height: 2px;
    border-radius: 2px;
    background: #4b5267;
}

.acting-as-label{
    margin-right: 0.5rem;
    font-size: 0.9rem;
    color: #4b5267;
}
.acting-as-label strong{ color: #5b3df0; }

.brand-mini{ font-weight: 700; font-size: .95rem; color: #4b5267; letter-spacing: -.01em; }
.brand-mini strong{ color: #5b3df0; }
</style>
